import { store } from 'store';
import API from 'utils/api';
import getFormattedValues, { DATETIME_FORMAT, formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

const baseURI = 'recaudacion/conceptos-de-multas/';

/**
 * GET Conceptos de multas
 * @returns {Promise<Array<object>>}
 */
export const getConceptosDeMultas = async (params = {}) => {
  try {
    const { periodoFiscalSelected } = store.getState()?.auth;
    const response = await API.get(baseURI, {
      ...params,
      periodo_fiscal: periodoFiscalSelected.id,
    });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Concepto de multa
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getConceptoDeMulta = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Concepto de Multas
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postConceptoDeMultas = async (values) => {
  try {
    const { periodoFiscalSelected } = store.getState()?.auth;
    const _values = {
      ...getFormattedValues(values),
      fecha: values?.fecha.format(DATETIME_FORMAT),
      fecha_final: values?.fecha_final.format(DATETIME_FORMAT),
      periodo_fiscal: periodoFiscalSelected.id,
    };
    const response = await API.post(baseURI, _values);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH  Concepto de multas
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchConceptoDeMultas = async (id, values) => {
  try {
    const formattedValues = {
      ...getFormattedValues(values),
      fecha: values?.fecha.format(DATETIME_FORMAT),
      fecha_final: values?.fecha_final.format(DATETIME_FORMAT),
    };
    const response = await API.patch(`${baseURI}/${id}`, formattedValues);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE  Concepto de multas
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteConceptoDeMulta = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
